import React from 'react';

interface DetailItemProps {
  label: string;
  value: React.ReactNode;
  labelWidth?: string;
  className?: string;
}

const DetailItem = ({
  label,
  value,
  labelWidth = '40%',
  className,
}: DetailItemProps) => {
  return (
    <div className={'text-neutral-whiteboard flex ' + (className ?? '')}>
      <div
        className={'font-medium max-w-[200px] flex-shrink-0 align-top'}
        style={{ width: labelWidth }}
      >
        {label}
      </div>
      <div className={'font-bold flex-grow align-top break-words'}>{value}</div>
    </div>
  );
};

export default DetailItem;
